export const descriptionTruncate = (str, length) => {
  if (str?.length > length) {
    const shorten = str.substring(0, length)
    return shorten.substring(0, Math.min(shorten.length, shorten.lastIndexOf(' ')))
  }
  return str
}
